/*
 * CourseCreator Messages
 *
 * This contains all the text for the CourseCreator component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'app.containers.CourseCreator.header',
        defaultMessage: 'Course Name'
    },
    viewCurriculum: {
        id: 'app.containers.CourseCreator.viewCurriculum',
        defaultMessage: 'View Curriculum'
    },
    createTopic: {
        id: 'app.containers.CourseCreator.createTopic',
        defaultMessage: 'Create New Topic'
    },
    courseNameEmptyMessage: {
        id: 'app.containers.CourseCreator.courseNameEmptyMessage',
        defaultMessage: 'Course name cannot be empty'
    },
    productNameSelectionMessage: {
        id: 'app.containers.CourseCreator.productNameSelectionMessage',
        defaultMessage: 'Please select a product.'
    },
    courseNameValidationMessage: {
        id: 'app.containers.CourseCreator.courseNameValidationMessage',
        defaultMessage: 'Course name already exists'
    },
    courseSaveSuccessMessage: {
        id: 'app.containers.CourseCreator.courseSaveSuccessMessage',
        defaultMessage: 'Course saved successfully'
    },
    emptyYearValidationMessage: {
        id: 'app.containers.CourseCreator.yearValidationMessage',
        defaultMessage: 'Level/Year cannot be empty'
    },
    emptyTopicsValidationMessage: {
        id: 'app.containers.CourseCreator.emptyTopicsValidationMessage',
        defaultMessage: 'Topics cannot be empty'
    }
});



// WEBPACK FOOTER //
// ./app/containers/course-creator/messages.js